import React, { useContext, useRef, useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { isEmpty } from 'lodash'
import { InputText } from 'primereact/inputtext'
import { classNames } from 'primereact/utils'
import { CommonContext } from '../../component/common/context/commonContext'
import { getContentSize } from '../../utils/screenUtils'
import PdaTitle from '../../component/common/PdaTitle'
import { GoodsData, GoodsSearch } from '../../types/goods'
import GoodsDetailDialog from '../../component/inventory/GoodsDetailDialog'
import { GoodsDetailDialogReq } from '../../types/inventory'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const GoodsList = () => {
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()
    const scanRef = useRef<HTMLInputElement>(null)
    const scrollRef = useRef<HTMLDivElement>(null)
    const [searchText, setSearchText] = useState<string>('')
    const [total, setTotal] = useState<number>(0)
    const [height, setHieght] = useState<number>(getContentSize())
    const [visibleGoods, setVisibleGoods] = useState<boolean>(false)
    const [goods, setGoods] = useState<GoodsData[]>()
    const [goodsDialogProps, setGoodsDialogProps] = useState<GoodsDetailDialogReq>()
    const [params, setParams] = useState<GoodsSearch>({
        searchText: '',
        page: 1,
        pageSize: 10,
        sort: '',
        sortOrder: undefined,
        sortField: '',
    })

    useMountEffect(() => {
        setTimeout(() => {
            if (scanRef && scanRef.current) {
                scanRef.current.focus()
            }
        }, 300)
    })

    const findGoods = async (p: GoodsSearch) => {
        p.page = 1

        const { total, list } = await $http().get(`/goods`, {
            params: p,
        })
        console.log(list)
        setTotal(total)
        setGoods(list)
        setHieght(getContentSize())
        setTimeout(setTimeoutBridgeGoods, 300)
        setSearchText('')
        scanRef.current?.focus()
    }

    const setTimeoutBridgeGoods = () => {
        if (scrollRef.current) {
            scrollRef.current.addEventListener('scrollend', async () => {
                if (scrollRef.current && params.page && params.pageSize) {
                    const myElm = scrollRef.current
                    const isNext = total > params.page * params.pageSize

                    if (isNext && myElm.offsetHeight + myElm.scrollTop >= myElm.scrollHeight - 0.5) {
                        const p = {
                            ...params,
                            page: params.page + 1,
                        }

                        setParams(p)

                        const { list } = await $http().get(`/goods`, {
                            params: p,
                        })

                        if (goods) {
                            setGoods([...goods, ...list])
                        }
                    }
                }
            })
        }
    }

    const onKeyDownSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            if (!searchText) {
                $toast({ title: t(tokens.common.fail), text: t(tokens.common.please_enter_product_or_product_name), icon: 'warn' })
                return
            }

            const p = {
                ...params,
                searchText,
            }

            setParams(p)
            findGoods(p)
        }
    }

    const onClickGoods = (row: GoodsData) => {
        if (row) {
            setGoodsDialogProps({
                lctPathNm: `${row.areaNm} > ${row.sectorNm} > ${row.bayId} > ${row.rackRowId}${t(tokens.common.row)} ${row.rackColId}${t(
                    tokens.common.layer,
                )}`,
                lctSeq: row.lctSeq,
                goodsId: row.goodsId,
                invnSeq: row.invnSeq,
                lctTypCd: row.lctTypCd,
                locationAlias: row.locationAlias,
            })
            setVisibleGoods(true)
        }
    }

    const onGoodsDetailHide = (isChange: boolean) => {
        if (isChange) {
            findGoods(params)
        }

        setVisibleGoods(false)
    }

    return (
        <>
            <PdaTitle title={t(tokens.common.product_inquiry)} historyBack />
            <div className="pda-search">
                <div className="col-12 flex">
                    <InputText
                        ref={scanRef}
                        value={searchText}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.common.please_enter_product_info)}
                        onChange={(e) => setSearchText(e.currentTarget.value)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                        autoFocus={true}
                    />
                </div>
                {visibleGoods && goodsDialogProps && (
                    <GoodsDetailDialog isUpdate={false} visible={visibleGoods} onHide={(e) => onGoodsDetailHide(e)} data={goodsDialogProps} />
                )}
            </div>
            <div className="px-2">
                {goods && !isEmpty(goods) ? (
                    <div ref={scrollRef} className="overflow-y-scroll" style={{ height: height }}>
                        {goods.map((good) => (
                            <div
                                className="mt-1 border-1 border-round-2xl"
                                style={{ borderColor: '#D3D3D3' }}
                                key={`${good.goodsId}${good.lctSeq}${good.invnSeq}`}
                                onClick={() => onClickGoods(good)}
                            >
                                <div className="card w-full p-1">
                                    {good.lctSeq === null ? (
                                        <div className="flex font-bold text-sm pl-2 pb-0 pt-1">
                                            <span className="font-bold rdms-text-deepblue p-0">{good.goodsId}</span>
                                        </div>
                                    ) : (
                                        <div className="col-12 justify-content-between flex pt-1 pb-0 font-bold align-items-center text-sm grid">
                                            <div className={classNames('col-10 text-left pr-0 pb-0')}>
                                                <span className="font-bold rdms-text-deepblue">{`${good.areaNm} > ${good.sectorNm} > ${
                                                    good.bayId
                                                } > ${good.rackRowId}${t(tokens.common.row)} ${good.rackColId}${t(tokens.common.layer)} [ ${good.locationAlias} ]`}</span>
                                                
                                            </div>
                                            <div className={classNames('col-2 text-right pt-2 text-lg p-0')}>
                                                <span className="font-bold rdms-text-warning">{`${good.lctTypNm}`}</span>
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex py-0 font-bold text-md">
                                        <div className={classNames('col-12 text-left w-full')}>{good.goodsNm} | {good.sysCd} | {good.goodsIrCd}</div>
                                    </div>
                                    <div className="flex py-0">
                                        <div className={classNames('col-12 text-left text-sm w-full pt-0')}>
                                            {good.specTxt}
                                            {good.goodsQty !== null && (
                                                <>
                                                    <span style={{ marginLeft: '10px' }}>
                                                        {t(tokens.common.actual_inventory)}: {good.goodsQty ?? 0} {good.gdslsUnitCd}{' '}
                                                    </span>
                                                    <span style={{ marginLeft: '4px' }}>
                                                        {' '}
                                                        {t(tokens.common.scheduled_outbound)}: {good.pckGoodsQty ?? 0} {good.gdslsUnitCd}
                                                    </span>
                                                    <span style={{ marginLeft: '4px' }}>
                                                        {' '}
                                                        {t(tokens.common.movable)}: {good.avlbGoodsQty ?? 0} {good.gdslsUnitCd}
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex py-0">
                                        <div className={classNames('col-12 text-left text-sm w-full pt-0')}>
                                            {t(tokens.common.expiration_date)} : {good.shlfYmd} | {t(tokens.common.lot_no)} : {good.lotNo}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="font-bold text-center w-full vertical-align-middle" style={{ paddingTop: height / 3 }}>
                        {t(tokens.common.please_enter_product_info)}
                    </div>
                )}
            </div>
        </>
    )
}

export default GoodsList
